exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4c970839] .el-tabs__content{height:calc(100% - 50px);padding-right:30px!important}[data-v-4c970839] .el-tabs__content .el-tab-pane{overflow-y:auto;height:100%}.dialog-content[data-v-4c970839]{height:calc(100% - 48px);overflow-y:scroll}[data-v-4c970839] .el-input{width:180px}[data-v-4c970839] .el-form-item{margin-bottom:10px}", ""]);

// exports
